import { Center } from "@chakra-ui/react"
import FileUpload from "./FileUpload"

const ProfilePictureUpload = ({
  name,
  initialImageUrl,
  isDisabled,
}: {
  name: string
  initialImageUrl?: string
  isDisabled?: boolean
}) => {
  return (
    <Center>
      <FileUpload
        name={name}
        initialImageUrl={initialImageUrl}
        borderRadius="50%"
        width="200px"
        height="200px"
        backgroundPosition="center"
        backgroundSize="cover"
        boxShadow="xl"
        isDisabled={isDisabled}
      />
    </Center>
  )
}

export default ProfilePictureUpload
